<template>
  <el-card class="card-main">
    <el-form inline ref="searchForm" :model="searchForm">
      <el-form-item prop="projectId">
        <el-select v-model="searchForm.projectId" clearable filterable placeholder="请选择所属项目">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="issueType">
        <el-select v-model="searchForm.issueType" placeholder="请选择问题类型" clearable>
          <el-option v-for="(item, index) in hxIssueTypeList" :label="item.dicValue" :value="item.dicCode"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="issueStatus">
        <el-select v-model="searchForm.issueStatus" placeholder="请选择工单状态" clearable>
          <el-option v-for="([key, value], index) of orderStatusMap" :label="value" :value="key"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker class="picker" v-model="datePicker" type="daterange" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="monthChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" type="primary" icon="el-icon-plus">新增工单</el-button>
      <!-- v-if="$ButtonShow('LWO_SEL_05')" -->
      <el-dropdown v-if="$ButtonShow('LWO_SEL_05')" class="ml20" placement="bottom-start">
        <el-button type="primary">
          导出<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item style="width: 70px;">
            <CustomExport type="4" buttonType="text" :params="{ ...searchForm }">明细</CustomExport>
          </el-dropdown-item>
          <el-dropdown-item>
            <CustomExport type="5" buttonType="text" :params="{ ...searchForm }">清单</CustomExport>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="问题类型" show-overflow-tooltip prop="issueTypeName"></el-table-column>
      <el-table-column label="问题描述" show-overflow-tooltip prop="issueContent"></el-table-column>
      <!-- <el-table-column label="整改截至日期" show-overflow-tooltip prop="deadline"></el-table-column> -->
      <el-table-column label="提交时间" show-overflow-tooltip prop="ctime"></el-table-column>
      <el-table-column label="当前节点" show-overflow-tooltip prop="taskName"></el-table-column>
      <el-table-column label="工单状态" show-overflow-tooltip prop="issueStatus">
        <template v-slot="{ row }">{{
          orderStatusMap.get(row.issueStatus)
        }}</template>
      </el-table-column>
      <el-table-column label="已耗时" show-overflow-tooltip prop="time"></el-table-column>
      <el-table-column label="操作" width="200px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" v-if="row.processId" @click="showProcess(row)">查看</el-button>
          <el-button type="text" v-if="row.processId" @click="delInstance(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </global-pagination>

    <el-drawer :size="'500px'" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :node-id="selectInstance.nodeId" :instance-id="selectInstance.instanceId"
        :type="type" @handler-after="handlerAfter"></instance-preview>
    </el-drawer>

    <w-dialog :ok-loading="submitLoading" :title="`发起 - ${selectForm.formName}`" closeFree width="1100px"
      v-model="openItemDl" okText="提 交" @cancel="openItemDl = false" @ok="submitForm">
      <initiate-process ref="processForm" @render-ok="submitLoading = false" :code="selectForm.formId" v-if="openItemDl"
        @fail="submitLoading = false" @ok="submitSuccess" />
    </w-dialog>
  </el-card>
</template>

<script>
import InstancePreview from "@/views/wflow/workspace/approval/ProcessInstancePreview";
import InitiateProcess from "@/views/wflow/workspace/InitiateProcess";
import { delProcessInst } from "@/api/process";
import { orderStatus } from "@/utils/dict";
export default {
  name: "ProcessWorkOrder",
  components: { InstancePreview, InitiateProcess },
  data() {
    return {
      processVisible: false,
      selectInstance: {
        instanceId: "",
        nodeId: "",
      },
      submitLoading: false,
      openItemDl: false,
      searchForm: {
        projectId: "",
        issueType: "",
        issueStatus: "",
        startTime: "",
        endTime: "",
      },
      loading: false,
      orderStatusMap: orderStatus,
      hxIssueTypeList: [],
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      datePicker: [],
      type: 'wt'
    };
  },
  filters: {},
  watch: {},
  computed: {
    customer() {
      return this.$store.state.customer;
    },
    projectList() {
      return this.$store.state.projectList || [];
    },
    selectForm() {
      return {
        formName: "巡查问题",
        formId: "wfAB1728887695099" + this.customer,
      };
    },
  },
  created() {
    if (
      this.$route.query.projectId ||
      (this.$route.query.startTime && this.$route.query.endTime)
    ) {
      this.searchForm.projectId = this.$route.query.projectId;
      this.searchForm.startTime = this.$route.query.startTime;
      this.searchForm.endTime = this.$route.query.endTime;
      this.datePicker = [
        this.$route.query.startTime,
        this.$route.query.endTime,
      ];
    }
    this.loadData();
    this.loadDict();
  },
  methods: {
    loadDict() {
      this.$axios
        .get(this.$apis.common.selectDicByList, { dicType: "hxIssueType" })
        .then((res) => {
          this.hxIssueTypeList = res.hxIssueType || [];
        });
    },
    onSearch() {
      this.page = 1;
      this.tableData = [];
      this.loadData();
    },
    monthChange(val) {
      if (val && val.length) {
        this.searchForm.startTime = val[0];
        this.searchForm.endTime = val[1];
      } else {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      }
    },
    loadData() {
      this.loading = true;
      this.$axios
        .get(this.$apis.process.selectLcPatrolIssueByPages, {
          page: this.page,
          size: this.size,
          ...this.searchForm,
        })
        .then((res) => {
          this.tableData = res.list || [];
          this.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onAdd() {
      this.openItemDl = true;
      this.submitLoading = true;
    },
    delInstance(row) {
      this.$confirm(
        "删除后将失去该流程实例所有数据且无法恢复，是否继续 ?",
        "警告",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        delProcessInst(row.processId)
          .then((rsp) => {
            this.loadData();
            this.$ok(rsp, "删除流程实例成功");
          })
          .catch((err) => {
            this.$err(err, "删除流程实例失败");
          });
      });
    },
    submitSuccess() {
      this.openItemDl = false;
      this.submitLoading = false;
      this.loadData();
    },
    submitForm() {
      this.$refs.processForm.validate((validForm, validProcess) => {
        if (validForm && validProcess) {
          this.submitLoading = true;
          this.$refs.processForm.submit();
        } else {
          this.$message.warning("请完善表单/流程选项😥");
        }
      });
    },
    showProcess(row) {
      console.log(row);

      this.processVisible = true;
      this.selectInstance = {
        instanceId: row.processId,
        nodeId: row.nodeId,
      };
    },
    handlerAfter() {
      this.processVisible = false;
      this.loadData();
    },
    handleExport(command) {

    }
  },
};
</script>

<style scoped lang="scss"></style>
